export default __webpack_public_path__ + "static/media/sies.272a7856.png";